import { Cell } from '../grid/Cell'
import { BaseModal } from './BaseModal'
import { TwitterIcon } from '../misc/TwitterIcon'
import { MAX_CHALLENGES } from '../../constants/settings'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const InfoModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="طريقة اللعب" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        خمِّن كلمة &nbsp;
        <b>
          <i>الوِرد</i>
        </b>
        &nbsp; في &nbsp;
        {MAX_CHALLENGES}
        &nbsp; محاولات. سيتغيّر لون المربعات بعد كل محاولة لإظهار مدى قرب تخمينك
        من الكلمة.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="ا"
          status="correct"
        />
        <Cell value="ب" />
        <Cell value="ت" />
        <Cell value="س" />
        <Cell value="م" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        حرف الألف موجود في الكلمة في المكان الصحيح.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="ي" />
        <Cell value="ت" />
        <Cell value="ح" />
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="د"
          status="present"
        />
        <Cell value="ث" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        حرف الدال موجود في الكلمة ولكن في المكان الخطأ.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="ج" />
        <Cell value="س" />
        <Cell value="ي" />
        <Cell isRevealing={true} isCompleted={true} value="م" status="absent" />
        <Cell value="ة" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        حرف الميم غير موجود في الكلمة في أي مكان.
      </p>

      <div className="mb-7"></div>
      <div>
        <p className="text-sm text-gray-500 dark:text-gray-300">
          لعبة الوِرد هي النسخة العربية من لعبة Wordle الشهيرة.
          <br />
          قام كلّ من{' '}
          <a
            className="underline"
            href="https://twitter.com/latiifsh"
            target="_blank"
            rel="noreferrer"
          >
            <TwitterIcon dimension={20}></TwitterIcon>
            <b>عبد اللطيف الشريف</b>
          </a>{' '}
          و{' '}
          <a
            className="underline"
            href="https://twitter.com/Amrkeleg"
            target="_blank"
            rel="noreferrer"
          >
            <TwitterIcon dimension={20}></TwitterIcon>
            <b>عمرو قلج</b>
          </a>{' '}
          بتكييف اللعبة مع اللغة العربية باستخدام هذه النسخة مفتوحة المصدر:{' '}
          <a
            href="https://github.com/cwackerfuss/react-wordle"
            className="underline font-bold"
          >
            react-wordle
          </a>
          <br />
          <br />
          تابعنا على
          <a
            className="underline"
            href="https://twitter.com/AlWirdArabic"
            target="_blank"
            rel="noreferrer"
          >
            <TwitterIcon dimension={20}></TwitterIcon>
            <b>AlWirdArabic@</b>
          </a>{' '}
        </p>
        <br />
        <p className="text-xs text-gray-500 dark:text-gray-300">
          شرح الكلمات يعرضه{' '}
          <a
            className="underline"
            href="https://www.almaany.com/"
            target="_blank"
            rel="noreferrer"
          >
            قاموس المعاني
          </a>
        </p>
      </div>
    </BaseModal>
  )
}
